import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: BACKEND_URL,
  withCredentials: true,
});

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

/**
 * Turns an axios error into a specific, actionable message instead of a
 * blanket "Something went wrong" — distinguishes a genuine connection
 * failure (no response reached the server at all) from an expired
 * session from an actual validation/server error with a real detail.
 */
export function getFriendlyErrorMessage(err) {
  if (!err?.response) {
    return "Could not reach the server — your connection may have dropped. Please try again in a moment; your answers on screen are safe.";
  }
  const status = err.response.status;
  if (status === 401 || status === 403) {
    return "Your session has expired. Please sign in again — your answers on screen are safe until you refresh.";
  }
  const detail = err.response.data?.detail;
  if (detail == null) {
    return `The server returned an unexpected error (${status}). Please try again.`;
  }
  return formatApiError(detail);
}
